export default function Bracket({ matches, players }) {
  const playerMap = Object.fromEntries((players || []).map((p) => [p.id, p]));
  const rounds = {};
  (matches || []).forEach((m) => {
    rounds[m.round] = rounds[m.round] || [];
    rounds[m.round].push(m);
  });
  const roundKeys = Object.keys(rounds).map(Number).sort((a, b) => a - b);
  const labelFor = (idx, total) => {
    if (idx === total - 1) return "FINAL";
    if (idx === total - 2) return "SEMI";
    if (idx === total - 3) return "QUARTER";
    return `R${idx + 1}`;
  };

  return (
    <div
      className="overflow-x-auto"
      data-testid="bracket-container"
    >
      <div className="flex gap-8 min-w-fit p-2">
        {roundKeys.map((r, idx) => (
          <div key={r} className="flex flex-col justify-around min-w-[260px]">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#00E5FF] mb-3 font-display">
              {labelFor(idx, roundKeys.length)}
            </div>
            <div className="flex flex-col gap-6 justify-around h-full">
              {rounds[r]
                .sort((a, b) => a.slot - b.slot)
                .map((m) => {
                  const a = playerMap[m.player_a_id];
                  const b = playerMap[m.player_b_id];
                  const isCompleted = m.status === "completed";
                  const winnerIs = (id) => isCompleted && m.winner_id === id;
                  return (
                    <div
                      key={m.id}
                      data-testid={`match-${m.id}`}
                      className="border border-white/15 bg-[#0C0C14] hover:border-[#00E5FF]/50 transition-colors duration-200"
                    >
                      <Row
                        name={a?.handle || "TBD"}
                        country={a?.country}
                        score={m.player_a_id ? m.score_a : ""}
                        winner={winnerIs(m.player_a_id)}
                        side="top"
                      />
                      <div className="border-t border-white/10" />
                      <Row
                        name={b?.handle || "TBD"}
                        country={b?.country}
                        score={m.player_b_id ? m.score_b : ""}
                        winner={winnerIs(m.player_b_id)}
                        side="bot"
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Row({ name, country, score, winner }) {
  return (
    <div
      className={`flex items-center justify-between px-3 py-2 ${
        winner ? "bg-[#00E5FF]/10" : ""
      }`}
    >
      <div className="flex items-center gap-2 min-w-0">
        {country && (
          <span className="text-[10px] font-mono text-white/40 px-1.5 py-0.5 border border-white/10">
            {country}
          </span>
        )}
        <span
          className={`text-sm font-semibold truncate ${
            winner ? "text-[#00E5FF]" : "text-white/80"
          }`}
        >
          {name}
        </span>
      </div>
      <span
        className={`font-mono text-sm font-bold tabular-nums ${
          winner ? "text-[#00E5FF]" : "text-white/40"
        }`}
      >
        {score === "" ? "-" : score}
      </span>
    </div>
  );
}
